import type { ApiSettings } from '@hultafors/shared/types';

// Default settings for .com staging site
export const defaultSettings: ApiSettings = {
  defaultCoords: {
    latitude: 57.6983323,
    longitude: 12.7388379,
  },
  hostname: 'www.hultaforsgroup.com',
  language: {
    // BCP47 lang code for HTML tags
    datoLocale: 'en',
    lang: 'en-US', // Culture to call DATO endpoint
  },
  market: 'com',
  siteName: 'Hultafors Group',
};
